export default __webpack_public_path__ + "static/media/Speed.a0cdc1be.mp3";